export const NAVIGATION_BUTTON = "NavigationButton";
export const NAVIGATION_ID = "NavigationId";
